import React, { useContext, useState } from "react";
import Utils from "../../../Common/Utils";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import Label from "../../Common/components/Label";
import { toast } from "react-toastify";
import GMSFillButton from "../../Common/components/GMSFillButton";
import { Modal } from "react-bootstrap";
import PDWTracker from "./PDWTracker";

/**
 * Component to bulk manage products for each categories
 * using xls sheets
 *
 * @param {array} categoryTypeId - category types
 * @param {object} categoriesList - {[categoryTypeId]: [categories]}
 * @returns
 */
const ReversePDW = ({ categoriesList, categoryTypeList }) => {
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const channelKey = appData?.channelKey;
  const [selectedCategory, setselectedCategory] = useState({
    id: null,
    name: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  //const modalOpen = () => setShowPopup(true);
  const modalClose = () => setShowPopup(false);
  const [filteredList, setFilteredList] = useState({ ...categoriesList });
  let [searchString, setSearchString] = useState("");

  let [downloadUrl, setDownloadUrl] = React.useState(null);
  let [downloadStausLog, setDownloadStausLog] = React.useState(null);
  //let timer = null;

  async function do_download_pdw() {
    if(!channelKey)return
    // setLoading({status: "Loading", message: "Downloading reverse pdw"});
    setDownloadStausLog(null);
    // let guid = Utils.generate_guid();
    setDownloadUrl("");
    let newurl = `${api_base_url}pdw/reverse/${industryId}/${selectedCategory.id}/${channelKey}`;
    let res = await ServiceWrapper.doGet(
      newurl,
      null,
      null,
      AuthManager.getGmsToken()
    );
    setDownloadStausLog("Making request");
    setTimeout(() => {
      check_download_status(res.data.jobid);
    }, 1000);
  }

  async function check_download_status(jobid) {
    let ret = await ServiceWrapper.doGet(
      api_base_url + "job/status/" + jobid,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      setDownloadStausLog(ret.data.status);
      if (!ret.data.data) {
        if(ret.data?.processing){
          setTimeout(() => {
            check_download_status(jobid);
          }, 1000);
        } else if(ret.data.error){
          toast.error(ret.data.status);
        } else {
           toast.info(ret.data.status);
        }
      } else {
        setDownloadUrl(ret.data.data);
        // delete_status_file(jobid);
        setDownloadStausLog("completed");
        toast.success("Completed");
        setTimeout(() => {
          setDownloadUrl(null);
          setDownloadStausLog(null);
          setselectedCategory({ id: null, name: null });
        }, 4000);
      }
      // if (ret.data.data.length > 0) await load_categories(ret.data.data[0].id);
    }
  }

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = []
        .concat(
          ...Object.values(categoriesList).map((categoryTypeItems) => {
            return categoryTypeItems.filter((item) => {
              return (
                (item.name != null &&
                  item.name.toLowerCase().includes(searchval)) ||
                (item.description != null &&
                  item.description.toLowerCase().includes(searchval))
              );
            });
          })
        )
        .reduce((acc, category) => {
          (acc[category.cattype] = acc[category.cattype] || []).push(category);
          return acc;
        }, {});
      setFilteredList(filteredData);
    } else {
      setFilteredList(categoriesList);
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center border-bottom tw-py-2 ms-2 flex-wrap">
        <div className="tw-flex-wrap">
          <Label
            message="Download Products"
            fontSize={0.875}
            fontWeight="600"
          />
          <br />
          <Label
            message="Select category to download all products. To update changes in current products, update the downloaded XLS file and import to PDW."
            fontSize={0.75}
            fontWeight="400"
            color="#5c5f62"
          />
        </div>
        <div className="d-flex">
          <div>
            <div
              className=" mt-0 d-flex  input-group border rounded-2 me-2"
              style={{ float: "right" }}
            >
              <input
                type="search"
                className="form-control flex-grow-1 border-0 shadow-none fw-normal"
                placeholder={"Search..."}
                value={searchString}
                onChange={(e) => handleSearchAttribute(e.target.value)}
                style={{
                  width: 260,
                  paddingTop: 0,
                  paddingBottom: 2,
                  placeholderTextColor: "#D8D8DC",
                  fontSize: 12,
                  fontFamily: "Noto Sans",
                }}
              />
              <div
                className="input-group-append"
                style={{
                  width: 30,
                  height: 36,
                  paddingTop: 2,
                  paddingBottom: 2,
                }}
              >
                <button
                  className="btn btn-info-secondary p-1"
                  type="button"
                  style={{ pointerEvents: "none" }}
                >
                  <i className="fa fa-search" style={{ color: "#D8D8DC" }} />
                </button>
              </div>
            </div>
          </div>

          <div>
            <GMSFillButton
              name="Download as XLS"
              disabled={selectedCategory.id === null}
              onClick={() => {
                if (appData.pm.checkPermission("gmsproducts_read")) {
                  do_download_pdw();
                } else {
                  toast.info("You don’t have permission to view the products");
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className="pb-2 px-3">
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
          show={showPopup}
          onHide={modalClose}
        >
          <Modal.Header closeButton>
            <div>
              <Label message={"PDW Logs"} fontSize={0.875} fontWeight="600" />
            </div>
          </Modal.Header>
          <Modal.Body>
            <PDWTracker />
          </Modal.Body>
        </Modal>

        <div className="mx-2">
          {categoryTypeList.map((categoryType, key) => {
            // chack if category type has any categories present
            if (
              !filteredList[categoryType.id] ||
              filteredList[categoryType.id].length <= 0
            )
              return <></>;

            return (
              <div key={key}>
                <div className="pt-3 pb-2">
                  <Label
                    message={categoryType.name}
                    fontSize={0.7}
                    fontWeight="600"
                    color="#6B778C"
                  />
                </div>
                <div className="row">
                  {filteredList[categoryType.id]?.map((item, index) => (
                    <div className="col-sm-3" key={item.id}>
                      <div className="form-check" style={{ marginBottom: 10 }}>
                        <label
                          className="form-check-label"
                          style={{
                            fontFamily: "Noto Sans",
                            fontSize: ".75rem",
                            fontWeight: "500",
                          }}
                        >
                          <input
                            style={{ fontSize: 11, color: "rgb(9, 28, 170)" }}
                            type="radio"
                            className="form-check-input"
                            name="optradio"
                            checked={selectedCategory.id === item.id}
                            value={selectedCategory.id || ""}
                            readOnly
                            onClick={(e) =>
                              setselectedCategory({
                                id: item.id,
                                name: item.name,
                              })
                            }
                          />
                          {item.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <br />

        <br />
        <br />

        {downloadStausLog === "completed" && (
          <>
            <div
              className="alert alert-primary bg-white small p-2 mt-2"
              role="alert"
            >
              &nbsp;&nbsp;
              <span className="fas fa-check" />
              &nbsp;&nbsp;
              <strong>{downloadStausLog}</strong>
            </div>
          </>
        )}
        {downloadStausLog !== null && downloadStausLog !== "completed" && (
          <>
            <div
              className="alert alert-primary bg-white small p-2 mt-2"
              role="alert"
            >
              &nbsp;&nbsp;
              <span className="fas fa-circle-notch fa-spin" />
              &nbsp;&nbsp;
              <strong>{downloadStausLog}</strong>
            </div>
          </>
        )}

        <iframe
          style={{ display: "none" }}
          src={downloadUrl}
          id="iframe_pdw_download"
          title="Reverse PDW"
        />
      </div>
    </div>
  );
};
export default ReversePDW;